/*
 * Move the quick-add button inside the card's media box.
 *
 * padelpoint.ca overlays "Add To Cart" on the bottom of the product image,
 * revealed on hover. Dawn renders quick-add in the text block *below* the
 * media, so `position: absolute` anchors it to the whole card rather than the
 * image — CSS can't reparent, so the node is relocated here and the reveal /
 * colour treatment is handled in brand.css (section 24).
 *
 * Idempotent: cards already processed are skipped, so re-running after a
 * section re-render is harmless.
 */
(function () {
  function relocate(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(function (wrapper) {
      if (wrapper.dataset.brandCtaMoved) return;

      var media = wrapper.querySelector('.card__inner');
      var quickAdd = wrapper.querySelector('.quick-add, .quick-add-bulk');
      if (!media || !quickAdd || media.contains(quickAdd)) return;

      media.appendChild(quickAdd);
      wrapper.dataset.brandCtaMoved = '1';
    });
  }

  /*
   * Category tiles: make the whole tile clickable, not just the lime pill.
   * The pill is the only anchor in the markup, and the content layer is lifted
   * over the media with pointer-events disabled so the image stays hoverable —
   * which left the obvious click target (the tile) doing nothing. Overlaying a
   * pseudo-element proved brittle against Dawn's stacking, so the click is
   * simply forwarded. Ctrl/cmd/middle-click still open a new tab because the
   * anchor itself is untouched and real clicks on it are ignored here.
   *
   * Product cards need the same treatment for a different reason: giving the
   * media its own stacking context (so the quick-add button is clickable) also
   * lifts it above Dawn's whole-card link overlay, leaving only the title text
   * clickable. Forwarding restores clicking the image.
   */
  function makeCardsClickable(root, selector) {
    (root || document).querySelectorAll(selector).forEach(function (card) {
      if (card.dataset.brandTileBound) return;
      var link = card.querySelector('.card__heading a');
      if (!link) return;
      card.dataset.brandTileBound = '1';
      card.style.cursor = 'pointer';

      card.addEventListener('click', function (event) {
        // Let real links and the quick-add button behave normally.
        if (event.target.closest('a, button')) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        link.click();
      });
    });
  }

  /*
   * Promo banners: the reference makes the whole banner clickable, not just the
   * CTA inside it. Same click-forwarding approach as the tiles — the banner is
   * a section wrapper, not an anchor, and wrapping it in one would fight Dawn's
   * block structure.
   */
  function makeBannersClickable(root) {
    (root || document).querySelectorAll('.banner').forEach(function (banner) {
      if (banner.dataset.brandBannerBound) return;
      var link = banner.querySelector('.banner__buttons a, .button');
      if (!link || !link.getAttribute('href')) return;
      banner.dataset.brandBannerBound = '1';
      banner.style.cursor = 'pointer';

      banner.addEventListener('click', function (event) {
        if (event.target.closest('a, button')) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        link.click();
      });
    });
  }

  function init(root) {
    relocate(root);
    makeCardsClickable(root, '.collection-list .card');
    makeCardsClickable(root, '.card-wrapper.product-card-wrapper');
    makeBannersClickable(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Sections re-render on filter/sort and in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /*
   * Cards can also arrive after load: the collection grid swaps its markup on
   * filter changes, and <product-recommendations> fetches Related Products by
   * AJAX — which is why that row kept its quick-add stuck under the title while
   * every other row had it overlaid. One observer on <body> catches both.
   */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () { init(); }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
